var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"toast-info"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.theToast),expression:"theToast"}],staticClass:"toast"},[_vm._v(" "+_vm._s(_vm.msg)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }